import React, { Component } from 'react';
import { changePassIcon } from '../Images/Images.js'
import { agentSVG } from '../Images/GenericSVG.js'
import { alertSVG } from '../Images/AlertsSVG.js'
import { APIFactory } from 'cw-galatea-api-js/cw-galatea-api-js-bundle.js'
import { connect } from 'react-redux';
import { loginAction, change_language } from '../redux/actions/A_user_actions';
import { consultingApp, noConsultingApp } from '../redux/actions/A_reducer_consulting';
import { sendMessageAgentReady } from '../redux/actions/A_messages_to_SM';
import { logout } from '../redux/actions/A_user_actions';
import Logo from "./Logo/Logo";
import { Singleton } from '../js/Singleton';
import { SingletonSharedData } from '../js/singletonSharedData';
import PasswordTextArea from './workSpace/Others/PasswordTextArea'
import { Logger } from '../js/helpers/Logger';
import { INTEGRATION, SOFTPHONES_KEY } from '../constants';
import SingletonWebSocket from '../js/Singletons/SingletonWebSocket';
import { UtilityFactory } from 'global-common-utilities-js/global-common-utilities-js-bundle.js'
import { setDialingMode } from '../redux/actions/A_preview.js';
import { setAllowChangeDialing, setAllowPlayRecordsOnCallHistory } from '../redux/actions/A_agent_permissions.js';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password: '',
      userName: '',
      isLoading: false,
      messageError: '',
      errorCode: 0,

    };
    let APIFact = new APIFactory();
    this.apiCont = APIFact.buildClient();
    this.language = new Singleton();
    let utilityFactory = new UtilityFactory();
    this.sharedData = new SingletonSharedData();
    this.urlClient = utilityFactory.buildURLClient();
    this.disable = false;
  }

  componentDidMount() {
    this.refs["userText"].focus();
    if (this.props.whiteLabelEnabled && this.props.customLogoFormat === 'svg') {
      const container = document.getElementById("custom-logo-login");
      container.innerHTML = this.props.customLogo;
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.whiteLabelEnabled !== this.props.whiteLabelEnabled && this.props.whiteLabelEnabled && this.props.customLogoFormat === 'svg') {
      const container = document.getElementById("custom-logo-login");
      container.innerHTML = this.props.customLogo;
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.loginError !== this.state.errorCode) {
      let messageError = this.language.getText('error-' + nextProps.loginError);
      this.setState({ isLoading: false, messageError: messageError, errorCode: nextProps.loginError });
      this.props.logout();
      var _this = this;
      const message = {
        code: this.state.errorCode,
        message: messageError
      }
      const integrationMessage = { client: "galatea", data: message, action: "remoteLoginError" };
      SingletonWebSocket.send(integrationMessage);
      if (nextProps.loginError !== 1045) {
        setTimeout(function () { _this.setState({ messageError: '', errorCode: 0 }); }, 4000);
      } else {
        this.disable = true;
      }
    }
    if (nextProps.languageLoaded) {
      this.forceUpdate();
    }
    if (nextProps.messagesIntegrations) {
      if (nextProps.messagesIntegrations.dataMessageIntegration && nextProps.messagesIntegrations.dataMessageIntegration.action === INTEGRATION.LOGIN) {
        var data = nextProps.messagesIntegrations.dataMessageIntegration;
        this.loginAgent(data.user, data.password);
      }
    }
  }
  loginAgent(user, password) {
    var _this = this;
    let objectResponse = this.apiCont.getObjectResponse();
    this.setState({ isLoading: true });    
    Logger.Trace("[Login][loginAgent] user => ", user, "[Login][loginAgent] password => *******");
    var loginData = {
      user, password, ipAddress: this.sharedData.getIPAddress(),
      isRemote: _this.sharedData.getSoftPhone() !== SOFTPHONES_KEY.MIZUJS
    };
    this.apiCont.agentLogin(loginData, objectResponse);
    this.props.consultingApp();
    objectResponse.onError = function (messageError) {
      Logger.Warning("[Login][loginAgent] Error Login => ", messageError.InternalCode + " " + _this.language.getText('error-' + messageError.InternalCode));
      _this.setState({ isLoading: false, messageError: _this.language.getText('error-' + messageError.InternalCode) });
      _this.props.noConsultingApp();
      const message = {
        code: messageError.InternalCode,
        message: _this.language.getText('error-' + messageError.InternalCode)
      }
      const integrationMessage = { client: "galatea", data: message, action: "remoteLoginError" };
      SingletonWebSocket.send(integrationMessage);
    };
    objectResponse.onSuccess = function (objResponse) {
      Logger.Debug("[Login][loginAgent] Success Login => ", objResponse);
      _this.setState({ isLoading: false });
      _this.sharedData.setUserData(objResponse.Response.user);
      _this.sharedData.setParameters(objResponse.Response.parameters);
      _this.sharedData.setPermissions(objResponse.Response.permissions);
      _this.sharedData.setGeneralPermissions(objResponse.Response.generalPermissions);
      _this.sharedData.setAllowMarksPermission(objResponse.Response.permissions.AllowMarks);
      _this.props.setAllowPlayRecordsOnCallHistory(objResponse.Response.permissions.AllowPlayRecordsOnCallHistory); 
      _this.props.setAllowChangeDialing(objResponse.Response.user.AllowSelectCamp); 
      _this.sharedData.setRequestTimeout(_this.sharedData.getGeneralPermissions()[226]);
      _this.props.noConsultingApp();
      _this.props.onLogin(); 
      _this.props.setDialingMode(objResponse.Response.user.DialingMode);   
      SingletonWebSocket.setUserId(Logger.getUserID());
      let setting131 = _this.sharedData.getGeneralPermissions()[131];
      var datoPBX = setting131.split("|");
      _this.sharedData.setVolumeSpeaker(datoPBX[4]);
      Logger.Debug("[Login][loginAgent] setVolumeSpeaker => ", datoPBX[4]);
      _this.sharedData.setVolumeMic(datoPBX[5]);
      Logger.Debug("[Login][loginAgent] setVolumeMic => ", datoPBX[5]);
    };
  }
  login() {
    if (!this.disable) {
      this.loginAgent(this.state.userName, this.state.password);
    }
  }
  onClickBtnLogin = () => {
    this.login();
  }

  render() {
    return (
      <div className="loginWindow">
        <div className="starsContainer">
          <div className="galaxy">
            <div className="stars-back"></div>
          </div>
        </div>
        <div className="loginContainer">
          <div className="loginBox" >
            {!this.props.whiteLabelEnabled ?
              <Logo title="Kolob" subtitle="" />
              :
              <div id='custom-logo-login'>{this.props.customLogoFormat === 'image' && <img id='custom-login-img' alt='' src={this.props.customLogo} />}</div>
            }
            <div className="loginForm">
              <div className={"errorLogin " + (this.state.messageError ? "errorVisible" : "")}>
                <div className="alertIconLogin">{alertSVG}</div>
                <p className="errorInfo">{this.state.messageError}</p>
              </div>
              <div className="loginFormContainer">
                <p className="labelLogin">{this.language.getText("GUILoginuser")}</p>
                <div className="userForm">
                  <div className="iconForm">{agentSVG}</div>
                  <input type="text"
                    ref="userText"
                    className="userText"
                    maxLength="40"
                    value={this.state.userName}
                    onChange={event => this.setState({ userName: event.target.value })} />
                </div>
                <p className="labelLogin margin">{this.language.getText("GUILoginpsw")}</p>
                <PasswordTextArea
                  value={this.state.password}
                  height={35}
                  width={"100%"}
                  margin={0}
                  onEnterKey={() => this.login()}
                  image={changePassIcon}
                  onChange={(text) => this.setState({ password: text })} />
                <div className={"buttonLogin " + ((!this.state.password || !this.state.userName || this.disable || !this.props.softPhoneLoaded) ? "disabled" : "")}
                  onClick={this.onClickBtnLogin}>
                  {this.state.isLoading ? this.language.getText("GUILoginloading") : this.language.getText("GUILoginlogin")}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
function mapDispatchToProps(dispatch) {
  return ({
    logout: () => { dispatch(logout()); },
    loginAction: (wLogged, ccsLogged) => { dispatch(loginAction(wLogged, ccsLogged)) },
    change_language: (c_language) => { dispatch(change_language(c_language)) },
    consultingApp: () => { dispatch(consultingApp()); },
    noConsultingApp: () => { dispatch(noConsultingApp()); },
    sendMessageAgentReady: () => { dispatch(sendMessageAgentReady()); },
    setDialingMode: data => { dispatch(setDialingMode(data)); },
    setAllowPlayRecordsOnCallHistory: data => { dispatch(setAllowPlayRecordsOnCallHistory(data)); },
    setAllowChangeDialing: data => { dispatch(setAllowChangeDialing(data)); }
  })
}
function mapStateToProps(state) {
  return {
    stateMachineActions: state.stateMachineActions,
    messagesIntegrations: state.messagesIntegrations,
    whiteLabelEnabled: state.whiteLabelState.whiteLabelEnabled,
    customLogo: state.whiteLabelState.login,
    customLogoFormat: state.whiteLabelState.imageFormat
  }
}
export default Login = connect(
  mapStateToProps,
  mapDispatchToProps
)(Login);



// WEBPACK FOOTER //
// ./src/components/Login.jsx